var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-menu-layout',[_c('train-configurations')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }